import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeHigh } from "@fortawesome/free-solid-svg-icons";

export default function AudioPlayer(props) {
  //special component for AudioPlayer
  //recieve data from Phonetic, to check what is inside, try command below
  //console.log(props.audio);
  let audio = new Audio(props.audio); //initialization of audio variable, we say "You are audio and your sond is in props"

  const start = () => {
    //labmda function for calling play audio
    audio.play();
    //alert(audio);
  };

  return <FontAwesomeIcon icon={faVolumeHigh} onClick={start} />;
}
//
